module.exports = __webpack_public_path__ + "static/img/ureter-detail-2.033ed3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/ureterpic/ureter-detail-2.jpg
// module id = Hbwo
// module chunks = 52